<template>
    <div class="order-copy pop_white-s pop_bege popup_wrap" style="display:block">
        <div class="popup_in">
            <div class="popup">
                <div class="popup_close stay_close close-animate">
                    <a href="javascript:void(0);" @click.prevent="closePop">
                        <close />
                    </a>
                </div>
                <div class="corner-top"></div>
                <div class="exists_icon">
                    <LOGO />
                </div>
                <div class="pop_frame">
                    <h2 class="title25" style="margin-top:20px;">עדכנו את ההזמנה הקבועה שלך</h2>
                    <div class="text text--small" v-if="status == 1">
                        במידה ויש לך הזמנה זמינה לעריכה ב-<a href="#0" @click.prevent="goToOrderHistory">היסטוריית הזמנות</a> השינויים שבצעת לא יחולו עליה ויש לערוך אותה בנפרד.<br/>
                        <span class="mobile_br">
                        -<br/>
                        משהו לא ברור? נשמח לעזור! 03-5162919
                        </span>
                    </div>
                    <div class="text text--small" v-if="status == 0">סטטוס ההזמנה הקבועה שלך התעדכן ויכנס לתוקף בעוד 48 שעות.
                        <br>
                        אם יש לך הזמנה שכבר יצאה לדרך,
                        <span class="mobile_br">
                        חשוב לדבר איתנו ב- 03-5162919
                        </span>
                    </div>
                    <div class="bt_green ease">
                        <a href="#" @click.prevent="closePop">סגור</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import close from "../../assets/img/close.svg";
    import LOGO from "../../assets/img/carmella.svg";
    import { mapState } from "vuex";
    export default {
        props: ["status","sendToComax"],
        data() {
            return {};
        },
        mounted() {
            if (this.status == 1 && typeof this.sendToComax !='undefined' && this.sendToComax){
                this.$ajax({
                    method: 'POST',
                    url: ajaxUrl,
                    params:{
                        action : 'send_order_to_comax',
                        order_id : this.permOrder.order_id
                    }
                }).then(res => {

                })
            }
        },
        computed:{
          ...mapState(["permOrder"])
        },
        methods: {
            goToOrderHistory(){
                this.$emit('close');
                this.$router.push('/my-account/history');
            },
            closePop() {
                this.$emit('close');
            }
        },
        components: {
            LOGO,
            close
        }
    };
</script>

<style scoped>
    .bt_green a {
        width: 320px;
    }
    .text--small{
        font-size: 14px;
    }
    @media screen and (max-width: 800px) {
    .mobile_br{
        display: block;
    }

    }
</style>
